import { Box, Button, InputLabel, Typography } from "@mui/material";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { professions } from "../asset/js/Professions";
import PostBidUploadImages from "./PostBidUploadImages";
import "./postbid-modern.css";

const animatedComponents = makeAnimated();

function PostBidGeneralInfo({ bidData, assistantDraft }) {
  const [next, setNext] = React.useState(false);
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const [error, setError] = useState(false);
  const options = Array.from(professions).map((profession) => ({ value: profession, label: profession }));

  const handleSubmit = (event) => {
    event.preventDefault();
    setError(false);
    if (!selectedOptions.length) {
      setError(true);
      return;
    }
    bidData.skills = selectedOptions.map((option) => option.value).join(",");
    setNext(true);
  };

  return (
    <Box className="bidit-postbid-step" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
      {!next && (
        <Box component="form" className="bidit-form-card" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }} onSubmit={handleSubmit}>
          <Box className="bidit-form-intro">
            <Box className="bidit-form-intro-badge"><span className="bidit-form-intro-spark">✦</span>שלב 2</Box>
            <Typography variant="h6" className="bidit-form-title" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
              מי בעל המקצוע שמתאים לעבודה?
            </Typography>
            <Typography className="bidit-form-subtitle" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
              בחרו מקצוע אחד או יותר, ואנחנו נדאג שהמכרז יגיע לאנשים הרלוונטיים
            </Typography>
          </Box>

          {assistantDraft?.recommendedProfession?.length > 0 && (
            <Box sx={{ mb: 2, p: 1.5, borderRadius: "12px", backgroundColor: "#FFF7EA", border: "1px solid #F3D7A5" }}>
              <Typography sx={{ fontFamily: "Assistant", fontWeight: 700 }}>המלצת הסייען: {assistantDraft.recommendedProfession.join(", ")}</Typography>
              <Typography sx={{ fontFamily: "Assistant", fontSize: 13, color: "#6F6350" }}>זו המלצה בלבד. בחרו בעצמכם את בעל המקצוע המתאים מהרשימה.</Typography>
            </Box>
          )}

          <InputLabel id="skills" sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, marginTop: "20px" }}>
            איזה בעל מקצוע אתם מחפשים?
          </InputLabel>
          <Select
            components={animatedComponents}
            isMulti
            name="professions"
            options={options}
            onChange={(items) => setSelectedOptions(items || [])}
            className="select bidit-profession-select"
            classNamePrefix="select"
            isClearable
            isSearchable
            closeMenuOnSelect={false}
            menuPosition="absolute"
            menuPlacement="bottom"
            menuShouldScrollIntoView={false}
            styles={{
              container: (base) => ({ ...base, position: "relative", marginBottom: 0 }),
              control: (base) => ({ ...base, marginBottom: 0 }),
              menu: (base) => ({
                ...base,
                position: "absolute",
                top: "calc(100% - 1px)",
                bottom: "auto",
                marginTop: 0,
                marginBottom: 0,
                transform: "none",
                zIndex: 1000,
              }),
              menuList: (base) => ({ ...base, paddingTop: 4, paddingBottom: 4 }),
            }}
            placeholder="חיפוש מקצוע מתוך הרשימה"
            noOptionsMessage={() => "המקצוע לא קיים כרגע ברשימה"}
          />

          <Box className="bidit-missing-profession">
            <Box>
              <Typography sx={{ fontFamily: "Assistant", fontWeight: 800, color: "#214c6d" }}>לא מצאתם את המקצוע?</Typography>
              <Typography sx={{ fontFamily: "Assistant", fontSize: 13.5, color: "#6c8191", mt: .3 }}>
                אל תזינו מקצוע חופשי שלא ניתן להתאים לבעלי מקצוע. ספרו לנו מה חסר ונבדוק אם כדאי להוסיף אותו.
              </Typography>
            </Box>
            <Button component={NavLink} to="/support" variant="outlined" className="bidit-secondary-button">יצירת קשר</Button>
          </Box>

          {error && <Box className="bidit-inline-error">יש לבחור מקצוע אחד לפחות</Box>}
          <Button type="submit" className="bidit-primary-button" fullWidth variant="contained" sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, mt: 3, mb: 2 }}>
            ממשיכים לתמונות וסרטונים
          </Button>
        </Box>
      )}
      {next && <PostBidUploadImages bidData={bidData} assistantDraft={assistantDraft} />}
    </Box>
  );
}

export default PostBidGeneralInfo;
